import { eNotificationType } from "../models/eNotificationType";
import { eSaleStatus } from "../models/eSaleStatus";

export function saleStatusTagClasses() : string[] {
	let a = [];
	a[eSaleStatus.PENDING_PAYMENT] = "sst_pending_payment";
	a[eSaleStatus.APPROVED_PAYMENT] = "sst_approved_payment";
	a[eSaleStatus.PENDING_SHIPPING] = "sst_pending_shipping";
	a[eSaleStatus.SHIPPING_DATE_SET] = "sst_shipping_date_set";
	a[eSaleStatus.IN_PROGRESS_DELIVERY] = "sst_in_progress_delivery";
	a[eSaleStatus.RECEIVED] = "sst_received";
	a[eSaleStatus.FAILED] = "sst_failed";
	a[eSaleStatus.CANCELED] = "sst_canceled";
	return a;
}

export function saleStatusColor() : string[] {
	let a = [];
	a[eSaleStatus.PENDING_PAYMENT] = "color_black_inactive";
	a[eSaleStatus.APPROVED_PAYMENT] = "color_accent_400";
	a[eSaleStatus.PENDING_SHIPPING] = "color_teal";
	a[eSaleStatus.SHIPPING_DATE_SET] = "color_primary_600";
	a[eSaleStatus.IN_PROGRESS_DELIVERY] = "color_warning";
	a[eSaleStatus.RECEIVED] = "color_success";
	a[eSaleStatus.FAILED] = "color_error";
	a[eSaleStatus.CANCELED] = "color_black_inactive";
	return a;
}

export function purchaseStatusColor() : string[] {
	let a = [];
	a[eSaleStatus.PENDING_PAYMENT] = "color_black_inactive";
	a[eSaleStatus.APPROVED_PAYMENT] = "color_accent_400";
	a[eSaleStatus.PENDING_SHIPPING] = "color_accent_400";
	a[eSaleStatus.SHIPPING_DATE_SET] = "color_primary_600";
	a[eSaleStatus.IN_PROGRESS_DELIVERY] = "color_warning";
	a[eSaleStatus.RECEIVED] = "color_success";
	a[eSaleStatus.FAILED] = "color_error";
	a[eSaleStatus.CANCELED] = "color_black_inactive";
	return a;
}

export function notificationIcons() : string[] {
	let a : string[] = [];
	a[eNotificationType.SELLER_REGISTER_COMPLETE] = "how_to_reg";
	a[eNotificationType.SELLER_REJECTED] = "person_off";
	a[eNotificationType.ACCOUNT_IN_REVIEW] = "person_search";
	a[eNotificationType.ABANDONED_CART] = "production_quantity_limits";
	a[eNotificationType.PURCHASED_PRODUCT_SELLER] = "local_atm";
	a[eNotificationType.PURCHASED_PRODUCT_BUYER] = "local_mall";
	a[eNotificationType.ADDED_QUESTION] = "live_help";
	a[eNotificationType.QUESTION_ANSWERED] = "question_answer";
	a[eNotificationType.SHIPMENT_PICKED_UP] = "airline_stops";
	a[eNotificationType.SHIPMENT_IN_PROCESS] = "local_shipping";
	a[eNotificationType.SHIPMENT_DELIVERED] = "pin_drop";
	a[eNotificationType.PURCHASE_RECEIVED] = "pin_drop";
	a[eNotificationType.NEW_ECOTREND] = "article";
	//a[eNotificationType.FEATURED_AD] = "yard"
	//a[eNotificationType.NEW_AD] = "pages"
	a[eNotificationType.EMITTED_MANUALLY] = "campaign";
	a[eNotificationType.SELLER_UPLOADED_INVOICE] = "price_check";

	return a;
}